// Library Imports
import React, { useState, FC } from 'react';

// Local Imports
import TableMainBody from './TableBody';
import TableHeader from './TableHeader';
import TablePagination from './TablePagination';

type CustomTableProps = {
  rows: any[];
  columns: any[];
  selectedIds: Number[];
  setSelectedIds: Function;
  tableColumnExtensions: any;
  dataProviders?: any;
  onRowClick?: Function;
  componentHeader?: Boolean
};

const CustomTable: FC<CustomTableProps> = ({
  rows,
  columns,
  selectedIds,
  setSelectedIds,
  tableColumnExtensions,
  dataProviders,
  onRowClick,
  componentHeader
}) => {
  // STATEs
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const rowsToShow =
    rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) || [];

  return (
    <React.Fragment>
      <div
        className={`relative flex flex-col text-black overflow-auto border-1 border-gray-200 rounded-md ${componentHeader ? 'h-[calc(100vh-184px)]' : 'h-[calc(100vh-168.5px)]'}`}
      >
        <table
          style={{ minWidth: 650 }}
          // size='small'
          aria-label='a dense table'
        >
          <TableHeader
            rows={rows}
            columns={columns}
            tableColumnExtensions={tableColumnExtensions}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
          {/* TABLE MAIN BODY ROWS */}
          <TableMainBody
            rows={rowsToShow}
            // rows={rows}
            columns={columns}
            tableColumnExtensions={tableColumnExtensions}
            dataProviders={dataProviders}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            onRowClick={onRowClick}
          />
        </table>
        {rowsToShow?.length === 0 &&
          <div className='absolute flex flex-col items-center top-20 left-[50%] translate-x-1/2'>
            <p className='mt-2 text-[#13343B] whitespace-nowrap text-sm'>
              No data found.
            </p>
          </div>
        }
      </div>

      {/* Pagination */}
      <TablePagination
        rows={rows}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleChangePage={handleChangePage}
      />
    </React.Fragment>
  );
};
export default CustomTable;
